import { Component } from '@angular/core';

@Component({
  selector: 'Comprehensive',
  templateUrl: './Comprehensive.html',
  styleUrls: ['./Comprehensive.css']
})
export class Comprehensive {
   
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Comprehensive/Comprehensive.ts